import { useState } from "react";
import PageHead from "../components/PageHead";
import CTA from "../components/CTA";
import { DashMock } from "./Home";

const Tick = () => (
  <svg className="tick" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <path d="M4 10.5l4 4 8-9" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/* Interactive extraction panel: 3 tabs, each with real data. */
function ExtractionPanel() {
  const [tab, setTab] = useState("kv");
  const tabs = [
    { id: "kv", label: "Key value pairs" },
    { id: "li", label: "Line items" },
    { id: "sm", label: "Summary" },
  ];
  return (
    <div className="review__panel" data-testid="extraction-panel">
      <div className="rphd">
        <span>Extraction results</span>
        <span style={{ color: "var(--teal-ink)" }}>9 fields · 3 line items</span>
      </div>
      <div className="rptabs" role="tablist">
        {tabs.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={tab === t.id}
            className={tab === t.id ? "active" : ""}
            onClick={() => setTab(t.id)}
            data-testid={`rptab-${t.id}`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === "kv" && (
        <div className="review__kv" role="tabpanel" data-testid="rpanel-kv">
          <div className="rkv"><span className="dot" style={{ background: "#5FB58C" }} /><div><b>Address</b><span>3340 Veterans Memorial Hwy, Suite 400</span></div><span className="rc">93%</span></div>
          <div className="rkv"><span className="dot" style={{ background: "#7C5BAA" }} /><div><b>Email</b><span>accounts@northridge-supply.com</span></div><span className="rc">93%</span></div>
          <div className="rkv"><span className="dot" style={{ background: "#D86A6A" }} /><div><b>Bill to</b><span>Todd Schirner · Allison Smith Co.</span></div><span className="rc rc--warn">61%</span></div>
          <div className="rkv"><span className="dot" style={{ background: "#3E86B5" }} /><div><b>Invoice #</b><span>1374</span></div><span className="rc">99%</span></div>
          <div className="rkv"><span className="dot" style={{ background: "#B0822F" }} /><div><b>Date</b><span>03/25/2026</span></div><span className="rc">98%</span></div>
        </div>
      )}

      {tab === "li" && (
        <div className="review__li" role="tabpanel" data-testid="rpanel-li">
          <div className="rli__head">
            <span>Activity</span>
            <span>Qty</span>
            <span>Rate</span>
            <span>Amount</span>
          </div>
          <div className="rli__row">
            <div className="rli__name"><b>Server upgrade</b><em>NR-SVR-250</em></div>
            <span className="rli__qty">1</span>
            <span className="rli__rate">2,400.00</span>
            <span className="rli__amt">2,400.00</span>
            <span className="rli__c">98%</span>
          </div>
          <div className="rli__row">
            <div className="rli__name"><b>Remote services</b><em>NR-PSV-910</em></div>
            <span className="rli__qty">1</span>
            <span className="rli__rate">1,400.00</span>
            <span className="rli__amt">1,400.00</span>
            <span className="rli__c">97%</span>
          </div>
          <div className="rli__row rli__row--neg">
            <div className="rli__name"><b>Upgrade discount</b><em>NR-DISCOUNT</em></div>
            <span className="rli__qty">1</span>
            <span className="rli__rate">−2,000.00</span>
            <span className="rli__amt">−2,000.00</span>
            <span className="rli__c">96%</span>
          </div>
          <div className="rli__foot">
            <span>3 of 3 line items captured</span>
            <span className="rli__total">Balance due&nbsp; <b>$1,800.00</b></span>
          </div>
        </div>
      )}

      {tab === "sm" && (
        <div className="review__sm" role="tabpanel" data-testid="rpanel-sm">
          <div className="rsm__eyebrow">Document summary</div>
          <p className="rsm__lead">
            <b>Invoice 1374</b> issued by <b>Northridge Supply Co.</b> (Trading division, 3340 Veterans Memorial Hwy, NY) and billed to <b>Allison Smith Company</b> (Todd Schirner, Smyrna, GA). It covers a server upgrade and remote services, netted against an upgrade discount, with a balance of <b>$1,800.00</b> due on <b>25 Mar 2026</b>.
          </p>
          <ul className="rsm__facts">
            <li><span>Vendor</span><b>Northridge Supply Co.</b></li>
            <li><span>Buyer</span><b>Allison Smith Company</b></li>
            <li><span>Contact</span><b>Todd Schirner</b></li>
            <li><span>Invoice number</span><b>1374</b></li>
            <li><span>Issued</span><b>25 Mar 2026</b></li>
            <li><span>Subtotal</span><b>$3,800.00</b></li>
            <li><span>Discount</span><b className="rsm__neg">−$2,000.00</b></li>
            <li><span>Balance due</span><b>$1,800.00</b></li>
            <li><span>Currency</span><b>USD</b></li>
          </ul>
          <div className="rsm__tags">
            <span className="rsm__tag">Net of discount</span>
            <span className="rsm__tag">No tax line</span>
            <span className="rsm__tag rsm__tag--warn">1 field flagged</span>
          </div>
        </div>
      )}

      <div className="rpfoot">
        <span>1 field flagged for review</span>
        <button type="button" className="save" data-testid="save-changes">Save changes</button>
      </div>
    </div>
  );
}

export default function Platform() {
  return (
    <>
      <PageHead
        crumb="Platform"
        eyebrow="The platform"
        title="Everything the document journey needs, in one platform."
        lede="Docket is not a point tool bolted onto a workflow. Training, classification, splitting, extraction, validation, delivery, reporting and audit all live in the same multi-tenant platform, so a document moves from upload to structured data without leaving it."
      />

      <section className="section">
        <div className="container">
          <div className="s-head reveal">
            <div className="eyebrow">What sets it apart</div>
            <h2>Trained, not generic. The difference shows in three places.</h2>
          </div>

          {/* Training */}
          <div className="frow">
            <div className="reveal">
              <div className="frow__tag">01 · Document Training</div>
              <h3>No data scientist required.</h3>
              <p className="frow__body">You teach Docket what your documents look like. The interface does the hard work, not the user, no ML expertise, no code. The same person who processes the documents every day can train and publish a working model.</p>
              <ul className="frow__list">
                <li><Tick /><span>A guided flow: choose a document type, upload samples, set a confidence threshold, publish.</span></li>
                <li><Tick /><span>Real machine-learning retraining, every reviewer correction becomes training signal.</span></li>
                <li><Tick /><span>Accuracy is grounded in your data, and compounds with every document processed.</span></li>
              </ul>
            </div>
            <div className="frow__media reveal d1">
              <div className="upload" aria-label="Example of the Docket training upload step">
                <div className="upload__head">
                  <span>New training job · Invoice model</span>
                  <span className="ubtn">Process documents
                    <svg width="11" height="11" viewBox="0 0 16 16" fill="none"><path d="M5 4l4 4-4 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>
                  </span>
                </div>
                <div className="upload__drop">
                  <div className="uic">
                    <svg viewBox="0 0 24 24" fill="none"><path d="M12 16V6m0 0L8 10m4-4 4 4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/><path d="M4 17v2.5a1 1 0 001 1h14a1 1 0 001-1V17" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>
                  </div>
                  <div>
                    <b>Drag &amp; drop files or <u>browse</u></b>
                    <span>PDF, JPG, PNG or TIFF, up to 50 MB each</span>
                  </div>
                </div>
                <div className="upload__list">
                  <div className="upload__file upload__file--focus">
                    <svg className="fi" viewBox="0 0 16 16" fill="none"><path d="M4 1.5h5.5L13 5v9.5H4z" stroke="currentColor" strokeWidth="1.3"/><path d="M9.5 1.5V5H13" stroke="currentColor" strokeWidth="1.3"/></svg>
                    <div><b>Allison Smith · Invoice 1374.pdf</b><span>2 pages · 196 KB</span></div>
                    <span className="ftype">PDF</span><span className="fx">×</span>
                  </div>
                  <div className="upload__file">
                    <svg className="fi" viewBox="0 0 16 16" fill="none"><path d="M4 1.5h5.5L13 5v9.5H4z" stroke="currentColor" strokeWidth="1.3"/><path d="M9.5 1.5V5H13" stroke="currentColor" strokeWidth="1.3"/></svg>
                    <div><b>Northwind · Invoice 0921.pdf</b><span>3 pages · 218 KB</span></div>
                    <span className="ftype">PDF</span><span className="fx">×</span>
                  </div>
                  <div className="upload__file">
                    <svg className="fi" viewBox="0 0 16 16" fill="none"><path d="M4 1.5h5.5L13 5v9.5H4z" stroke="currentColor" strokeWidth="1.3"/><path d="M9.5 1.5V5H13" stroke="currentColor" strokeWidth="1.3"/></svg>
                    <div><b>Meridian Supply · Invoice 4471.pdf</b><span>1 page · 142 KB</span></div>
                    <span className="ftype">PDF</span><span className="fx">×</span>
                  </div>
                  <div className="upload__file">
                    <svg className="fi" viewBox="0 0 16 16" fill="none"><path d="M4 1.5h5.5L13 5v9.5H4z" stroke="currentColor" strokeWidth="1.3"/><path d="M9.5 1.5V5H13" stroke="currentColor" strokeWidth="1.3"/></svg>
                    <div><b>Acme Logistics · Invoice 5598.pdf</b><span>2 pages · 188 KB</span></div>
                    <span className="ftype">PDF</span><span className="fx">×</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Splitting */}
          <div className="frow frow--flip">
            <div className="reveal">
              <div className="frow__tag">02 · Document Splitting</div>
              <h3>One file in. The right documents out.</h3>
              <p className="frow__body">A scanned batch or an emailed packet is rarely a single document. Docket detects where one document ends and the next begins, separates the file, and classifies each sub-document on its own merits.</p>
              <ul className="frow__list">
                <li><Tick /><span>No manual pre-sorting, the bottleneck simply disappears.</span></li>
                <li><Tick /><span>The right extraction model runs on the right pages, every time.</span></li>
                <li><Tick /><span>Page ranges are preserved, so every split traces back to the original file.</span></li>
              </ul>
            </div>
            <div className="frow__media reveal d1">
              <div className="split">
                <div className="split__src">
                  <svg className="doc-ic" viewBox="0 0 26 26" fill="none" aria-hidden="true"><path d="M6 2.5h9l5 5v16H6z" stroke="currentColor" strokeWidth="1.4"/><path d="M15 2.5v5h5" stroke="currentColor" strokeWidth="1.4"/><path d="M9 13h8M9 16.5h8M9 20h5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/></svg>
                  <div><div className="split__src-name">vendor-batch-07.pdf</div><div className="split__src-meta">11 pages · mixed document types</div></div>
                </div>
                <div className="split__connector" aria-hidden="true" />
                <div className="split__outs">
                  <div className="subdoc"><div className="subdoc__bar" /><div><div className="subdoc__type">Invoice</div><div className="subdoc__pages">pp. 1–4</div></div><div className="subdoc__conf">97.3%</div></div>
                  <div className="subdoc"><div className="subdoc__bar" /><div><div className="subdoc__type">Purchase Order</div><div className="subdoc__pages">pp. 5–8</div></div><div className="subdoc__conf">95.1%</div></div>
                  <div className="subdoc"><div className="subdoc__bar" /><div><div className="subdoc__type">Covering Letter</div><div className="subdoc__pages">pp. 9–11</div></div><div className="subdoc__conf">92.6%</div></div>
                </div>
              </div>
            </div>
          </div>

          {/* Validation */}
          <div className="frow frow--stack">
            <div className="frow__intro reveal">
              <div className="frow__intro-l">
                <div className="frow__tag">03 · Document Validation</div>
                <h3>Human judgement, only where it counts.</h3>
              </div>
              <div className="frow__intro-r">
                <p className="frow__body">High-confidence work flows straight through. Only fields that fall below your threshold reach a reviewer, on one screen, beside the source document, with every value linked to the pixels it came from.</p>
                <ul className="frow__list">
                  <li><Tick /><span>Selective routing keeps reviewer attention where it changes the outcome.</span></li>
                  <li><Tick /><span>Bounding-box links jump the viewer straight to the source of any field.</span></li>
                  <li><Tick /><span>Corrections feed back into training, review is a feature, not a failure.</span></li>
                </ul>
              </div>
            </div>
            <div className="frow__media frow__media--full reveal d1">
              <div className="review" aria-label="Example of the Docket validation workspace">
                <div className="review__doc">
                  <div className="review__head">
                    <span>INV-1374.pdf · 1 of 2</span>
                    <span className="seal">Invoice · 93%</span>
                  </div>
                  <div className="review__paper">
                    <div className="top">
                      <div>
                        <b>3340 Veterans Memorial Hwy</b><br />
                        Suite 400<br />
                        <span className="bb bb--addr">(631) 446-4800 · 11716 US</span><br />
                        <span className="bb bb--email">accounts@northridge-supply.com</span>
                      </div>
                      <div style={{ textAlign: "right" }}>
                        Northridge Supply Co.<br />
                        Trading division
                      </div>
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6, marginBottom: 12 }}>
                      <div>
                        <div style={{ color: "var(--ink-faint)", fontSize: 10, letterSpacing: ".06em", textTransform: "uppercase" }}>Bill to</div>
                        <span className="bb bb--bill">Todd Schirner<br />Allison Smith Company<br />1869 S. Cobb Industrial Blvd, SE<br />Smyrna, GA 30082</span>
                      </div>
                      <div style={{ textAlign: "right" }}>
                        <div style={{ color: "var(--ink-faint)", fontSize: 10, letterSpacing: ".06em", textTransform: "uppercase" }}>Invoice #</div>
                        <span className="bb bb--invno">1374</span><br />
                        <div style={{ color: "var(--ink-faint)", fontSize: 10, letterSpacing: ".06em", textTransform: "uppercase", marginTop: 6 }}>Date</div>
                        <span className="bb bb--date">03/25/2026</span>
                      </div>
                    </div>
                    <table>
                      <thead><tr><th>Activity</th><th>Qty</th><th>Rate</th><th>Amount</th></tr></thead>
                      <tbody>
                        <tr><td>NR-SVR-250 Server upgrade</td><td>1</td><td>2,400.00</td><td>2,400.00</td></tr>
                        <tr><td>NR-PSV-910 Remote services</td><td>1</td><td>1,400.00</td><td>1,400.00</td></tr>
                        <tr><td>NR-DISCOUNT Upgrade discount</td><td>1</td><td>−2,000.00</td><td>−2,000.00</td></tr>
                      </tbody>
                    </table>
                    <div className="totals">Balance due &nbsp; $1,800.00</div>
                  </div>
                </div>
                <ExtractionPanel />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CAPABILITY GRID */}
      <section className="section bg-2 bordered">
        <div className="container">
          <div className="s-head reveal" style={{ marginBottom: 48 }}>
            <div className="eyebrow">The full module set</div>
            <h2>A complete platform, module by module.</h2>
            <p className="lede">Beyond the three differentiators, Docket ships every module a document operation actually needs to run day to day.</p>
          </div>
          <div className="capgrid reveal">
            {[
              ["IDP Extraction", "The operator's workspace, a tabbed job queue with search, bulk actions, and a clear next step on every row."],
              ["Document Summary", "A plain-language summary for every document, the gist of a long contract or dense form, in seconds."],
              ["Output & Integration", "Deliver as CSV, XML, Excel or JSON, or connect straight into the DMS or system of record you already run."],
              ["User Management", "Invite users with per-module access toggles. Granular permissions, reversible actions, nothing over-provisioned."],
              ["Settings", "Eight configuration areas, thresholds, models, storage, SLAs, compliance, all tunable without engineering."],
              ["Audit Logs", "Every action captured, attributed and timestamped, with before/after diffs and filter-aware export."],
            ].map(([t, d]) => (
              <div key={t} className="cap">
                <div className="cap__ic"><svg viewBox="0 0 24 24" fill="none"><rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="1.6"/><path d="M8 9h8M8 12.5h8M8 16h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg></div>
                <h3>{t}</h3>
                <p>{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* DARK, REPORTS */}
      <section className="section dark">
        <div className="container">
          <div className="s-head reveal" style={{ marginBottom: 52 }}>
            <div className="eyebrow eyebrow--light">Reports &amp; dashboards</div>
            <h2>See everything. Prove anything.</h2>
            <p className="lede">Confidence scoring is the spine of the platform. Every field, document and model carries a score, and that score drives the dashboards, the reports, and the analytics.</p>
          </div>
          <div className="dark__grid">
            <div className="dark__points reveal">
              <div className="dpoint"><div className="dpoint__k">Dashboards</div><h3>The operational picture, live</h3><p>KPI tiles, a pipeline distribution bar, and built-in triage. Every tile links straight to the action behind it.</p></div>
              <div className="dpoint"><div className="dpoint__k">Reports</div><h3>Period-over-period, automatically</h3><p>Every metric carries its change against the prior equivalent period, no spreadsheet assembly required.</p></div>
              <div className="dpoint"><div className="dpoint__k">Analytics</div><h3>From score to recommendation</h3><p>Confidence trends surface which models to retrain and where review time is being spent, with a short analysis attached.</p></div>
            </div>
            <div className="reveal d1"><DashMock /></div>
          </div>
        </div>
      </section>

      <CTA
        title='See the whole platform on <em>your</em> documents.'
        text="The fastest way to understand Docket is to watch it train on the documents your team handles every day. That is exactly what a pilot does."
        secondary={{ to: "/how-it-works", label: "See how it works" }}
      />
    </>
  );
}
